import { render } from "./electricalList.vue?vue&type=template&id=ed7f4d3e"
import script from "./electricalList.vue?vue&type=script&lang=js"
export * from "./electricalList.vue?vue&type=script&lang=js"

import "./electricalList.vue?vue&type=style&index=0&id=ed7f4d3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__